export default
    {
         // url: this.$store.state.http.mecic.YYYY,
         guardaEvaluacion: "/calidadMecic/guardaEvaluacion",
         listEvaluaciones: "/calidadMecic/listEvaluaciones",
         guardaEvaluacionItems: "/calidadMecic/guardaEvaluacionItems",
         listEvaluacionItems: "/calidadMecic/listEvaluacionItems",
         listResumenEvaluacion: "/calidadMecic/listResumenEvaluacion",
         listDominios: "/calidadMecic/listDominios",
    }
